import { radii } from '../radius.js';
export const card = {
    borderRadius: radii.x1_5,
};
//# sourceMappingURL=card.js.map